module.exports = __webpack_public_path__ + "img/sophia-gardens-map.032657ba.png";